module.exports = __webpack_public_path__ + "img/carousel-bg.99797d20.png";